export const CREATE_ACCOUNT_ASSOCIATION = 'createAccountAssociation'
export const GET_ACCOUNT_ASSOCIATION = 'getAccountAssociation'
export const GET_USER_ACCOUNT_ASSOCIATIONS = 'getUserAccountAssociations'
export const GET_ACCOUNT_ASSOCIATION_TYPES = 'getAccountAssociationTypes'
export const DELETE_ACCOUNT_ASSOCIATION = 'deleteAccountAssociation'
